import React from 'react';

import { Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { SubHeader, Footer } from '../../components';

import './styles.scoped.css';

const menuOptions = [
  { text: 'Active Drivers', to: '/dms-driver-log/active-drivers' },
  { text: 'All Drivers', to: '/dms-driver-log/all-drivers' },
  { text: 'Search', to: '/dms-driver-log/search' },
];

const DmsDriverLog = () => {
  const navigate = useNavigate();

  return (
    <>
      <SubHeader
        text="DMS Driver Log"
        buttons={[{ icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
      />
      <div className="wrap">
        <div className="button-grid">
          {menuOptions.map(option => (
            <div key={option.text} className="nav-tile" onClick={() => navigate(option.to)}>
              {option.text}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DmsDriverLog;
